import { DEFAULT_QUERY_OPTIONS, useQueryWithBoundary } from '@/shared/lib/query';
import { domainKeys } from '@/shared/lib/query/queryKeys';

import { fetchSubDomains } from '@/features/domain/api/subDomainsApi';

type UseSubDomainsParams = {
  parentFqn: string;
  from?: number;
  size?: number;
  includeDeleted?: boolean;
  enabled?: boolean;
};

export const useSubDomains = ({
  parentFqn,
  from = 0,
  size = 50,
  includeDeleted = false,
  enabled = true,
}: UseSubDomainsParams) => {
  return useQueryWithBoundary({
    queryKey: domainKeys.subDomains(parentFqn),
    queryFn: () => fetchSubDomains({ parentFqn, from, size, includeDeleted }),
    enabled: enabled && !!parentFqn,
    staleTime: 5 * 60 * 1000,
    ...DEFAULT_QUERY_OPTIONS,
  });
};
